import Lum from 'luminate/src/lum'

export default function(context = document.body)
{
	Lum.start(context)
}



// WEBPACK FOOTER //
// ./source/scripts/legacy/init.js